import React from "react";
import { LoadingSpinner } from "./LoadingSpinner";

import { Fade } from "../fade/Fade";
import styles from "./LoadingOverlay.module.scss";

export const LoadingOverlay = ({ children, loading, ...props }) => (
  <div {...props} className={`${props.className ? props.className : ""} ${loading ? styles.loading_overlay_blur : ""}`}>
    <Fade visible={loading} className={styles.loading_overlay}>
      <LoadingSpinner />
    </Fade>
    {children}
  </div>
);
